import {
    SELECT_ALL_AVAILABLE_STUDENTS,
    SELECT_ALL_STUDENTS,
    UPDATE_AVAILABLE_STUDENT_LIST_SELECTION,
    UPDATE_CLASSROOM_NAME,
    UPDATE_YEAR_GROUP_FILTER_STUDENT,
    UPDATE_CLASS_LIST_STUDENT,
    UPDATE_GROUP_LIST,
    UPDATE_SCHOOL_FILTERS,
    UPDATE_SCHOOL_STUDENTS_STUDENTS,
    UPDATE_SELECTED_CLASS_GROUP,
    UPDATE_STUDENT_LIST_STUDENT,
    UPDATE_STUDENT_LIST_SELECTION,
    UPDATE_QUERY_PARAMS,
    UPDATE_SURNAME_FILTER_STUDENT,
    RESET_UNASSIGNED_RESOURCE,
    GET_SELECTED_STUDENTS_POST_MOVECOPY
} from './students-actions';

import { EXECUTE_CONFIRM_COMMAND } from '../confirmation-modal/confirmation-modal-actions';
import { filterStudentList, disableAvailableStudents, toggleSelected } from '../../helpers/utils';
import { NAVIGATE_MANAGE_STUDENTS } from '../whole-class/whole-class-actions';
import { FOOTER_BUTTON_CLICK } from '../../components/page-footer/page-footer-actions';

const initialState = {
    availableClassGroupId: 1,
    availableClassGroupStudents: [],
    availableClassGroups: [],
    availableClassId: 0,
    availableClasses: [],
    availableSelectedStudents: [],
    availableSurnameId: '',
    availableYearGroupId: -1,
    classGroupStudents: [],
    classGroups: [],
    classList: [],
    classroomName: 'My Class',
    confirmCommandInfo: null,
    fromWholeClass: false,
    selectAllAvailableStudents: false,
    selectAllStudents: false,
    selectedClassId: 0,
    selectedGroupId: 0,
    selectedStudentsPostMoveCopy: [],
    selectedStudents: [],
    surnames: [],
    yearGroups: [],
    queryParams: {},
    wholeClassId: undefined,
    wholeGroupId: undefined
};


export default function (state = initialState, action) {
    if (!action) return state;
    const payload = action.payload;
    switch (action.type) {
    case RESET_UNASSIGNED_RESOURCE:
        return {
            ...state,
            confirmCommandInfo: undefined
        };
    case UPDATE_SURNAME_FILTER_STUDENT:
        return {
            ...state,
            availableSurnameId: payload.availableSurnameId,
            availableClassGroupStudents:
                disableAvailableStudents(payload.availableClassGroupStudents, state.classGroupStudents),
            selectAllAvailableStudents: false
        };
    case UPDATE_YEAR_GROUP_FILTER_STUDENT:
        return {
            ...state,
            availableYearGroupId: payload.availableYearGroupId,
            availableClassGroupStudents:
                disableAvailableStudents(payload.availableClassGroupStudents, state.classGroupStudents),
            selectAllAvailableStudents: false
        };
    case UPDATE_STUDENT_LIST_STUDENT:
        return {
            ...state,
            classGroupStudents: payload.classGroupStudents,
            selectedStudents: [],
            availableClassGroupStudents:
                disableAvailableStudents(state.availableClassGroupStudents, payload.classGroupStudents),
            selectAllStudents: false
        };
    case UPDATE_SCHOOL_STUDENTS_STUDENTS:
        return {
            ...state,
            availableClassGroupStudents:
                disableAvailableStudents(payload.availableClassGroupStudents, state.classGroupStudents),
            availableSelectedStudents: [],
            selectAllAvailableStudents: false
        };
    case UPDATE_GROUP_LIST:
        return {
            ...state,
            classGroups: payload.classGroups,
            selectedGroupId: payload.classGroupId
        };
    case UPDATE_CLASS_LIST_STUDENT:
        return {
            ...state,
            classList: payload.classList
        };
    case UPDATE_CLASSROOM_NAME:
        return {
            ...state,
            classroomName: payload.classroomName
        };
    case UPDATE_SELECTED_CLASS_GROUP:
    {
        const newState = {
            ...state,
            selectedClassId: payload.selectedClassId
        };
        if (payload.selectedGroupId) {
            newState.selectedGroupId = payload.selectedGroupId;
        }
        return newState;
    }
    case UPDATE_SCHOOL_FILTERS:
    {
        const newState = {
            ...state,
            ...payload
        };
        return newState;
    }
    case UPDATE_STUDENT_LIST_SELECTION:
    {
        return filterStudentList(state, payload, 'selectedStudents', 'selectAllStudents', 'classGroupStudents');
    }
    case UPDATE_AVAILABLE_STUDENT_LIST_SELECTION:
    {
        return filterStudentList(state, payload, 'availableSelectedStudents', 'selectAllAvailableStudents',
            'availableClassGroupStudents');
    }
    case SELECT_ALL_AVAILABLE_STUDENTS:
    {
        const newState = {
            ...state,
            selectAllAvailableStudents: payload.value,
            availableSelectedStudents: payload.value ? state.availableClassGroupStudents : []
        };
        newState.availableClassGroupStudents = toggleSelected(newState.availableClassGroupStudents, payload.value);
        return newState;
    }
    case SELECT_ALL_STUDENTS:
    {
        const newState = {
            ...state,
            selectAllStudents: payload.value,
            selectedStudents: payload.value ? state.classGroupStudents : []
        };
        newState.classGroupStudents = toggleSelected(newState.classGroupStudents, payload.value);
        return newState;
    }
    case EXECUTE_CONFIRM_COMMAND:
        return {
            ...state,
            confirmCommandInfo: payload.commandInfo
        };
    case UPDATE_QUERY_PARAMS: {
        const query = state.queryParams;
        return {
            ...state,
            queryParams: {
                ...query,
                ...payload
            }
        };
    }
    case FOOTER_BUTTON_CLICK: {
        return {
            ...state,
            confirmCommandInfo: payload.type === 'BACK_TO_WHOLE_CLASS' ? 'back' : undefined
        };
    }
    case NAVIGATE_MANAGE_STUDENTS: {
        return {
            ...state,
            fromWholeClass: true,
            wholeClassId: payload.params.classId,
            wholeGroupId: payload.params.groupId,
            availableSurnameId: '',
            availableClassGroupId: 1,
            availableYearGroupId: -1,
            availableClassId: 0
        };
    }
    case GET_SELECTED_STUDENTS_POST_MOVECOPY: {
        return {
            ...state,
            selectedStudentsPostMoveCopy: payload
        };
    }
    default:
        return state;
    }
}




// WEBPACK FOOTER //
// ./containers/students/students-reducer.js